import React, { useState } from 'react';
import style from './HeaderMobile.module.css';
import { Link, useLocation } from 'react-router-dom';
import { nufolksLogo } from '../../assets';
import { Backdrop } from '@mui/material';

const HeaderMobile = () => {
    const location = useLocation();
    const [showSidebar, setShowSidebar] = useState(false);

    const openBackdrop = () => {
        setShowSidebar(!showSidebar);
    }
    const closeBackdrop = () => {
        setShowSidebar(false)
    }

    return (
        <div className={style.myheader_wrapper}>
            <header className={style.myheader}>
                <nav>
                    <Link to="/" className={style.navLogoLink}>
                        <img src={nufolksLogo} alt="NuFolks" className={style.navbar_logo} />
                    </Link>
                    <ul className={`${style.menubar} ${showSidebar ? style.active : ''}`}>
                        <li>
                            <Link to="/about" style={{fontFamily: "Helvetica"}} className={`${style.navLink} ${location.pathname === "/about" ? style.header_active : style.header_unactive}`} onClick={closeBackdrop}>About Us</Link>
                        </li>
                        <li>
                            <Link to="/success-stories" style={{fontFamily: "Helvetica"}} className={`${style.navLink} ${location.pathname === "/success-stories" ? style.header_active : style.header_unactive}`} onClick={closeBackdrop}>Success Stories</Link>
                        </li>
                        <li>
                            <Link to="/services" style={{fontFamily: "Helvetica"}} className={`${style.navLink} ${location.pathname === "/services" ? style.header_active : style.header_unactive}`} onClick={closeBackdrop}>Our Services</Link>
                        </li>
                        <li>
                            <Link to="/culture" style={{fontFamily: "Helvetica"}} className={`${style.navLink} ${location.pathname === "/culture" ? style.header_active : style.header_unactive}`} onClick={closeBackdrop}>Our Culture</Link>
                        </li>
                        <li>
                            <Link to="/blogs" style={{fontFamily: "Helvetica"}} className={`${style.navLink} ${location.pathname.startsWith("/blogs") ? style.header_active : style.header_unactive}`} onClick={closeBackdrop}>Our Blogs</Link>
                        </li>
                        <li>
                            <Link to="/hire-a-talent" style={{fontFamily: "Helvetica"}} className={`${style.hireTalent_btn} ${location.pathname === "/hire-a-talent" ? style.header_active : style.header_unactive}`} onClick={closeBackdrop}>Hire a Talent</Link>
                        </li>
                        <li>
                            <Link to="/jobs" style={{fontFamily: "Helvetica"}} className={`${style.applyTalent_btn} ${location.pathname === "/jobs" ? style.applyTalent_btn_active : style.applyTalent_btn_unactive}`} onClick={closeBackdrop}>Find a Job</Link>
                        </li>
                        {/* <li>
                            <Link to="/apply-as-talent" style={{fontFamily: "Helvetica"}} className={`${style.applyTalent_btn} ${location.pathname === "/apply-as-talent" ? style.applyTalent_btn_active : style.applyTalent_btn_unactive}`} onClick={closeBackdrop}>Find a Job</Link>
                        </li> */}
                    </ul>
                    <div className={`${style.menu} ${showSidebar ? style.active : ''}`} onClick={openBackdrop}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </nav>
            </header><Backdrop
                sx={{
                    color: "#fff",
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    zIndex: "99 !important",
                }}
                open={showSidebar}
                onClick={closeBackdrop}
            ></Backdrop>
        </div>
    );
};

export default HeaderMobile;
